import { NgModule } from '@angular/core';

import { FilterPipe } from '@core/pipes/filter.pipe';
import { InitialsPipe } from '@core/pipes/initials.pipe';
import { SafePipe } from '@core/pipes/safe.pipe';
import { StripHtmlPipe } from '@core/pipes/stripHtml.pipe';
import { SumPipe } from '@core/pipes/sum.pipe';
import { AgePipe } from './age.pipe';
import { CustomTitleCasePipe } from './custom-titlecase.pipe';
import { MomentPipe } from './moment.pipe';
import { NameFormatPipe } from './name-format.pipe';
import { SentenceCasePipe } from './sentence-case.pipe';
import { SortByDatePipe } from './sort-by-date.pipe';

@NgModule({
  declarations: [CustomTitleCasePipe, InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, SumPipe, NameFormatPipe, AgePipe, MomentPipe, SentenceCasePipe, SortByDatePipe],
  imports: [],
  exports: [CustomTitleCasePipe, InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, SumPipe, NameFormatPipe, AgePipe, MomentPipe, SentenceCasePipe, SortByDatePipe],
})
export class CorePipesModule {}
